import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  style: {"border-bottom":"#2e3854 1px solid"},
  class: "container-fluid position-relative d-flex align-items-center justify-content-between"
}

import SwitchLang from "@/components/element/lang/SwitchLang.vue";
import UserInforClient from "@/components/user/UserInforClient.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'MenuTop',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createVNode(SwitchLang)
    ]),
    _createElementVNode("div", null, [
      _createVNode(UserInforClient)
    ])
  ]))
}
}

})